<template>
  <div class="login" v-bind:style="{backgroundImage:'url('+loginImage+')'}">
    <div class="container">
      <div class="container_header">欢迎登录 - 金展律所</div>
      <el-form :model="formData" :rules="rules" ref="formData">
        <el-form-item prop="mobile">
          <div class="container_input">
            <i class="el-icon-phone"></i>
            <el-input class="el-input-login" placeholder="手机号" v-model="formData.mobile" autocomplete="off"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="userName">
          <div class="container_input">
            <i class="el-icon-user-solid"></i>
            <el-input  class="el-input-login" placeholder="姓名" v-model="formData.userName" autocomplete="off"></el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="container_input">
            <i class="el-icon-s-goods"></i>
            <el-input v-model="formData.smsCode" placeholder="短信验证码"></el-input>
            <el-button type="success" @click="smsSend('formData')" :disabled="disabled=!show">  
                <span v-show="show">获取验证码</span>
                <span v-show="!show" class="count">{{count}} s</span>
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <el-button class="container_button" type="success" @click="confirm('formData')" :disabled="disabled=formData.smsCode==''" :loading="isLoading">登录</el-button>
    </div>
  </div>
</template>

<script>
  import { validatePhone, validateUserName } from '@/utils/validate'
  import { setToken, setUserInfo, getUserInfo } from '@/utils/common'
  export default {
    name: "login",
    data() {
      return {
        isLoading: false,
        show: true,  // 初始启用按钮
        count: '',   // 初始化次数
        timer: null,
        time_count: 60, // 更改倒计时时间
        loginImage: require('@/assets/images/login_bg_img.jpg'),
        formData: {
          mobile:'',
          userName:'',
          smsCode:''
        },
        userInfo: {
          mobile: '',
          userName: '',
          token:'',
          uid: '',
          os:''
        },
        rules: {
          mobile:[
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { validator: validatePhone, trigger: 'blur' }
          ],
          userName:[
            { required: true, message: '请输入姓名', trigger: 'blur' },
            { validator: validateUserName, trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      // 登录
      confirm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true
            this.$axios.post(this.$apiUrl.LOGIN_API_URL, 'Form', {
              mobile: this.formData.mobile,
              userName: this.formData.userName,
              smsCode: this.formData.smsCode
            }).then(res => {
              this.isLoading = false
              if (res.data.code == 200) {
                this.userInfo.mobile = this.formData.mobile
                this.userInfo.userName = this.formData.userName
                this.userInfo.uid = res.data.data.uid
                this.userInfo.os = res.data.data.os
                this.userInfo.token = res.data.data.token
                setUserInfo( this.userInfo)
                setToken(res.data.data.token)
                this.$router.back()
                this.$message.success("登录成功")
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
                this.isLoading = false
                this.$message.error("服务器出现差错")
            })
          } else {
            return false
          }
        })
      },
      smsSend(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (!this.timer) {
              this.count = this.time_count;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= this.time_count) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);  // 清除定时器
                  this.timer = null;
                }
              }, 1000)
            }
            this.isLoading = true
            this.$axios.post(this.$apiUrl.SMS_SEND_API_URL, 'Form', {
              mobile: this.formData.mobile,
              nationCode: 86,
              type: 1001
            }).then(res => {
              this.isLoading = false
              if (res.data.code == 200) {
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
                this.isLoading = false
                this.$message.error("服务器出现差错")
            })
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style lang="less">
  .login {
    width: 100vw;
    height: 80vh;
    padding-top: 20vh;
    background: #ccc;
    background-repeat:no-repeat;
    background-position:0% 0%;
  	background-size:cover;
  }
  .el-input {
    width: 70%;
  }
  .el-input-login {
    width: 100%;
  }
  .container {
    width: 500px;
    margin: 0 auto;
    background: rgba(255,255,255,0.3);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    .container_header {
      width: 100%;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 20px;
      border-bottom: 1px solid #ccc;
      color: #000;
      background: transparent;
      margin-bottom: 20px;
    }
    .container_input {
      display: flex;
      align-items: center;
      i {
        min-width: 46px;
        height: 38px;
        display: flex !important;
        justify-content: center;
        align-items: center;
        border: 1px solid #ededed;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      input {
        border-radius: 0;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    .el-form-item__content {
      width: 80%;
      margin: 0 auto;
      .el-form-item__error {
        left: 46px;
      }
    }
    .container_button {
      width: 80%;
      margin: 20px auto;
    }
  }
  @media screen and (max-width: 450px) {
    .login {
      width: 100vw;
      height: 70vh;
      padding-top: 20vh;
      background: #ccc;
      background-repeat:no-repeat;
      background-position:0% 0%;
      background-size:cover;
    }
    .el-input {
      width: 50%;
    }
    .el-input-login {
      width: 100%;
    }
    .container {
      width: 90%;
      margin-bottom: 10px;
      .container_header {
        width: 100%;
        height: 60px;
        font-size: 16px;
        line-height: 60px;
      }
      .container_input {
        margin-top: 0px;
        i {
          min-width: 38px;
          height: 38px;
        }
      }
    }
  }
</style>